export const PRODUCTION_WEBSITE_URL = `https://www.elsewhere.club`;
export const CURRENCY = 'USD';
export const LOCALE = 'en-US';
export const TIMEZONE_NAME = 'America/New_York';
export const SHOP_URL = '/shop';
export const SHOP_DEFAULT_COLLECTION_HANDLE = 'all';
export const SHOP_COLLECTIONS_URL = `${SHOP_URL}/collections`;
export const SHOP_PRODUCTS_URL = `${SHOP_URL}/products`;
export const SHOP_METAFIELD_NAMESPACE = 'elsewhere';
export const SHOP_CART_STORAGE_KEY = 'cart';
export const SPACES_URL = '/spaces';
export const ZINE_URL = '/zine';
export const ZINE_TAG_URL = `${ZINE_URL}/tag`;
export const CART_LINE_COUNT = 60;
export const MEMBERSHIPS_URL = 'https://web.elsewhere.club/pages/memberships';
export const JOINIT_SIGN_IN_URL =
	'https://app.joinit.com/o/elsewhereclub/members';

export const EVENT_INDEX_PAGE_SIZE = 36;

export const PAGINATION_ELLIPSIS = '...';
export const ZINE_POSTS_PER_PAGE = 17;

// https://docs.imgix.com/apis/rendering
export const DEFAULT_IMGIX_PARAMS = {
	auto: ['compress', 'format'],
	q: 80,
};

export const EVENT_DESCRIPTION_DELIMITER = '[extra-info]';

export const CONTACT_FORM_DEFAULT_ERROR_MESSAGE =
	'Something went wrong while trying to deliver your message. Please try again later';
